import React from "react"
import PropTypes from "prop-types"
import Comment from "./Comment"
import CommentForm from "./CommentForm"
import styled from "styled-components"

import * as commentsStyles from './comments.module.scss'

const CommentList = styled.div`
  article {
    margin-bottom: 2rem;
  }
`

const Comments = ({ comments, blogId, path }) => {
  return (
    <div id="comments">
      <h2 className={commentsStyles.heading}>Leave a Comment</h2>
      <p className={commentsStyles.headingText}>I love reading comments! I'll do my best
      to answer questions, too. If you made the recipe, please leave a star rating,
      it helps support the blog so I can make more recipes and articles. Thank you!</p>

      <CommentForm blogId={blogId} path={path} key={blogId} />
      <CommentList key={path} >
        {comments.length > 0 &&
          comments
            .filter(comment => !comment.pId)
            .sort((a, b) => {
              return b.time - a.time
            })
            .map(comment => {
              let children
              if (comment.id) {
                children = comments.filter(c => comment.id === c.pId)
              }
              return (
                
                  <Comment
                    children={children}
                    comment={comment}
                    blogId={blogId}
                    path={path}
                    key={comment.id}
                  />
              )
            })}
      </CommentList>
    </div>
  )
}

Comments.propTypes = {
  blogId: PropTypes.string.isRequired,
  comments: PropTypes.array.isRequired
}

export default Comments